export const ShopifyDependencyTypes = {
    ShopifyApolloClient: Symbol.for('ShopifyApolloClient'),
    ShopifyStore: Symbol.for('ShopifyStore'),
    ShopifyProductAssemblerService: Symbol.for('ShopifyProductAssemblerService'),
    ShopifyProductsQueryBuilderService: Symbol.for('ShopifyProductsQueryBuilderService'),
};
